import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../services/services";
import { Urls } from "../../services/Urls";
import _ from "underscore";
import { ToastContext } from "../../context/ToastContext";
import { useLateArrival } from "../Features/Punctuality/useLateArrival";
import { decryptData } from "../../utils/encrypt";
import { callautopopulate } from "../../services/callautopop";

export const useInbox = (props) => {

    const { showSuccess, showInfo } = useContext(ToastContext)
    const [currentUser] = useState(decryptData(sessionStorage.getItem("user_code")))
    const [selectedData] = useState({});
    const { handleSubmitReason } = useLateArrival({ selectedData, currentUser });
    const [notifications, setNotifications] = useState([]);
    const [currentCategory, setCurrentCategory] = useState("All");
    const [categories, setCategories] = useState(["All"]);
    const [filterNotification, setFilterNotification] = useState([]);
    const [punctualityData, setPunctualityData] = useState([]);
    const [remark, setRemark] = useState({});
    const [isRead, setIsRead] = useState(false);
    const [reasonList,setReasonList] = useState([]);

    useEffect(() => {
        callautopopulate("unpunctuality_reasons").then(async res => {
            setReasonList(res?.unpunctuality_reasons)
        })
    }, []);

    useEffect(() => {
        let data;
        if (!_.isEmpty(props?.punctualityData)) {
            data = _.filter(props?.punctualityData, item => item.user_code === parseInt(currentUser) && ((item?.is_late_in && !item.in_remark) || (item?.is_early_out && !item.out_remark)))
                .map(item => ({
                    ...item,
                    notification_type_name: "Unpunctual",
                    is_read: 0,
                    num_of_remarks: (item?.is_late_in && item?.is_early_out) ? 2 : (item?.is_late_in || item?.is_early_out) ? 1 : 0
                }));
            setPunctualityData(data);

        }
        !isRead ? setNotifications(props?.notifiData) : setNotifications(props?.readData)
        const category = _.uniq(_.pluck(!isRead ? props?.notifiData : props?.readData, "notification_type_name"))
        data?.length > 0 && !isRead ? setCategories(["All", "Unpunctual", ...category]) : setCategories(["All", ...category])
        setCurrentCategory("All")
    }, [props, isRead])

    useEffect(() => {
        setFilterNotification(notifications?.filter(n => currentCategory === "All" || n.notification_type_name === currentCategory))
    }, [currentCategory, notifications])

    const markAllAsRead = async (id) => {
        try {
            const unreadNotifications = notifications.filter(n => !n.is_read);
            if (unreadNotifications?.length === 0) {
                showInfo("warn", "All notifications are already read!");
                return;
            }
            const payload = {
                notification_queue_ids: id ? id : _.uniq(_.pluck(unreadNotifications, "notification_queue_id")).toString()
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTNOTIFICATIONQUEUE"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message)
                if (id) {
                    setNotifications(prev => prev.filter(n => n.notification_queue_id !== id));
                } else {
                    setNotifications([]);
                }
                if (_.isEmpty(notifications?.filter(n => n.notification_queue_id !== id)) || !id) {
                    props?.setNotifiData([]);
                }
            }
        } catch (error) {
            console.error("err", error)
        }
    };



    const countUnread = (cat) => {
        if (isRead) return
        if (cat === "All") return [...notifications, ...punctualityData].filter(n => !n.is_read).length;
        return [...notifications, ...punctualityData].filter(n => n.notification_type_name === cat && !n.is_read).length;
    };

    const sendRemark = async (data) => {
        try {
            const success = await handleSubmitReason(true, data, remark[data?.shift_date]);
            if (success) {
                props?.GetEmployeeAttandance();
                props?.GetEmployeeAttandanceSummary();
            }
        } catch (error) {
            console.error("Error saving remark: ", error);
        }
    }

    return useMemo(() => ({
        categories, currentCategory, setCurrentCategory, markAllAsRead, countUnread, filterNotification, remark, sendRemark, punctualityData, setRemark, isRead, setIsRead,reasonList
    }), [categories, currentCategory, setCurrentCategory, markAllAsRead, countUnread, filterNotification, remark, sendRemark, punctualityData, setRemark, isRead, setIsRead,reasonList])
}